import '../app/polyfills';

import 'react-hot-loader/patch';
import { AppContainer } from 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import configureStore from '../app/store/configureStore';
import thunk from 'redux-thunk';

import WidgetRoot from './containers/widget-root';
import { setConfig } from '../app/services/config';
import { createRequest } from '@wix/communities-blog-client-common';
import { getInstance } from '../app/services/wix-sdk-utils';
import * as appLifecycleService from '../app/services/app-lifecycle-service';
import { initClientI18n } from '../recent-posts-widget-common/services/i18n-utils';
import listenToSettingsChange from '../app/services/listen-to-settings-change';
import actionLoggerMiddleware, { shouldLogReduxActions } from '../app/middleware/action-logger-middleware';
import reducer from '../recent-posts-widget-common/reducers';
import { debug } from '../app/services/debug';

setConfig(window.__CONFIG__);

const apiBaseUrl = window.__API_BASE_URL__ || '';
const instance = getInstance();
const locale = window.__LOCALE__;
const request = createRequest({ apiBaseUrl, instance, locale });

const middlewares = [thunk.withExtraArgument({ request })];

shouldLogReduxActions() && middlewares.push(actionLoggerMiddleware);

const store = configureStore(window.__INITIAL_STATE__ || {}, middlewares, reducer);

listenToSettingsChange(store);

const renderApp = (Application) => {
  appLifecycleService.appIsLoading();
  const renderFn = ReactDOM.hydrate || ReactDOM.render;
  renderFn(
    <AppContainer>
      <Application store={store} i18n={initClientI18n()} />
    </AppContainer>,
    document.getElementById('root'),
  );
};

renderApp(WidgetRoot);

if (module.hot) {
  module.hot.accept('./containers/widget-root', () => {
    debug.log('HOT RELOAD START');
    // While using 'separateCss: true', external css files must be manually reloaded
    document.querySelectorAll('link[href][rel=stylesheet]').forEach((link) => {
      const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`);
      link.href = nextStyleHref;
    });

    renderApp(require('./containers/widget-root').default);
    debug.log('HOT RELOAD END');
  });
}
